import { createFileRoute } from '@tanstack/react-router'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { QuestionnairesWorkspace } from '@/components/questionnaires/questionnaires-workspace'

export const Route = createFileRoute('/_app/clients/$clientId/questionnaires')({
  component: ClientQuestionnairesPage,
})

function ClientQuestionnairesPage() {
  const client = useShellClient()
  return (
    <Frame>
      <QuestionnairesWorkspace fixedClient={{ id: client.id, name: client.name }} />
    </Frame>
  )
}
